/** Type guard shared by P2P handoff parsers (untrusted JSON). */
export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}
